import React from 'react';
import VerificationAnalyticsLineChart from '../../components/VerificationAnalyticsLineChart';

export default function VerificationLineChart({
  chartData = [],
  customElements,
  periodType,
  loading,
}) {
  return (
    <div className="mt-6 bg-white shadow-cards rounded-xl border border-[#EFEFEF]">
      <div className="px-6 py-3 bg-[#F9F9F9] rounded-t-xl relative flex items-center justify-between w-full">
        <p className="text-base text-[#4A4A68] font-medium">
          No. of Verifications
        </p>

        {customElements}
      </div>
      <VerificationAnalyticsLineChart
        data={chartData}
        periodType={periodType}
        loading={loading}
      />
    </div>
  );
}
